import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faFilter, faSearch, faSyncAlt, faFileDownload, faSpinner, faUpload } from '@fortawesome/free-solid-svg-icons';
import { Input } from '@material-tailwind/react';

const ExpenseHeader = ({
    onAdd,
    canAdd = true,
    onImport,
    canImport = true,
    showFilters,
    setShowFilters,
    onRefresh,
    onExport,
    exportLoading = false,
    searchTerm,
    setSearchTerm,
    exportDisabled
}) => {
    return (
        <div className="flex flex-wrap gap-3 items-center justify-between">
            <div className="flex flex-wrap gap-3">
                {canAdd && (
                    <button
                        onClick={(e) => {
                            e.currentTarget?.blur();
                            requestAnimationFrame(() => onAdd());
                        }}
                        className="bg-[#FF5733] hover:bg-[#e64520] text-white text-sm font-semibold rounded-sm px-3 py-2 shadow-none flex items-center gap-2"
                        >
                        <FontAwesomeIcon icon={faPlus} /> Add Expense
                    </button>
                )}
                {canImport && (
                    <button
                        onClick={(e) => {
                            e.currentTarget?.blur();
                            requestAnimationFrame(() => onImport?.());
                        }}
                        className="bg-[#FF5733] hover:bg-[#e64520] text-white text-sm font-semibold rounded-sm px-3 py-2 shadow-none flex items-center gap-2"
                    >
                        <FontAwesomeIcon icon={faUpload} /> Import CSV
                    </button>
                )}
                <button
                    onClick={() => setShowFilters(!showFilters)}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold rounded-sm px-3 py-2 shadow-none flex items-center gap-2"
                >
                    <FontAwesomeIcon icon={faFilter} /> {showFilters ? 'Hide Filters' : 'Show Filters'}
                </button>
                <button
                    onClick={onRefresh}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold rounded-sm px-3 py-2 shadow-none flex items-center gap-2"
                >
                    <FontAwesomeIcon icon={faSyncAlt} /> Refresh
                </button>
                <button
                    onClick={onExport}
                    disabled={exportDisabled}
                    className="bg-slate-100 hover:bg-slate-200 text-slate-700 text-sm font-semibold rounded-sm px-3 py-2 shadow-none flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <FontAwesomeIcon icon={exportLoading ? faSpinner : faFileDownload} spin={exportLoading} />
                    {exportLoading ? 'Exporting...' : 'Export CSV'}
                </button>
            </div>
            <div className="w-full md:w-auto">
                <Input
                    label="Search expenses..."
                    icon={<FontAwesomeIcon icon={faSearch} />}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
        </div>
    );
};

export default ExpenseHeader;
